export default "__VITE_ASSET__Dovn$UFZ__"